import { render } from "./ThankYouView.vue?vue&type=template&id=0e2e9a2e&lang=html"
import script from "./ThankYouView.vue?vue&type=script&lang=js"
export * from "./ThankYouView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__